import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSearchResultsMeta } from '@/redux/selectors/search/meta';
import { getDistanceFromLatLonInMiles } from '@/utility/map';

/**
 * Hook to check if provided coordinates are within a radius of a target location
 * @param lat - Current latitude
 * @param lng - Current longitude
 * @param targetLat - Target latitude
 * @param targetLng - Target longitude
 * @param radiusMiles - Radius in miles (default: 100)
 * @returns boolean indicating if current location is within radius
 */
const useNearLocation = (
  lat: number,
  lng: number,
  targetLat: number,
  targetLng: number,
  radiusMiles: number = 100,
): boolean => {
  return useMemo(() => {
    if (!lat || !lng) return false;
    return getDistanceFromLatLonInMiles(lat, lng, targetLat, targetLng) <= radiusMiles;
  }, [lat, lng, targetLat, targetLng, radiusMiles]);
};

// Convenience hooks that use search meta coordinates
export const useNearFortWilderness = () => {
  const { lat, lng } = useSelector(getSearchResultsMeta);
  return useNearLocation(lat, lng, 28.4053845, -81.5588722);
};

export const useNearHouston = () => {
  const { lat, lng } = useSelector(getSearchResultsMeta);
  return useNearLocation(lat, lng, 29.8314155, -96.709876);
};
